(function () {
  function ahHydrateHeroSlide(slide) {
    if (!slide) return;
    var img = slide.querySelector('img.ah-hero__img[data-src]');
    if (!img) return;
    var src = img.getAttribute('data-src');
    if (!src) return;
    img.removeAttribute('data-src');
    img.src = src;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ah-hero]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-ah-hero-slide]');
      var dots = root.querySelectorAll('[data-ah-dot]');
      var nameEl = root.querySelector('[data-ah-hero-name]');
      var productEl = root.querySelector('[data-ah-hero-product]');
      var tagEl = root.querySelector('[data-ah-hero-tag]');
      var copyEl = root.querySelector('[data-ah-hero-copy]');
      var ctaEl = root.querySelector('[data-ah-hero-cta]');
      var autoplayMs = parseInt(root.getAttribute('data-ah-hero-autoplay') || '5200', 10);
      var index = 0;
      var timer = null;

      function applySlide(i) {
        if (!slides.length) return;
        index = ((i % slides.length) + slides.length) % slides.length;
        var slide = slides[index];
        var theme = slide.getAttribute('data-theme') || 'dark';

        ahHydrateHeroSlide(slide);

        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        dots.forEach(function (d, n) {
          var on = n === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        root.classList.toggle('is-light', theme === 'light');

        if (copyEl) {
          copyEl.classList.remove('is-switching');
          void copyEl.offsetWidth;
          copyEl.classList.add('is-switching');
        }
        if (nameEl) nameEl.textContent = slide.getAttribute('data-name') || '';
        if (productEl) productEl.textContent = slide.getAttribute('data-product') || '';
        if (tagEl) {
          var tag = slide.getAttribute('data-tag') || '';
          tagEl.textContent = tag;
          if (tag) tagEl.removeAttribute('hidden');
          else tagEl.setAttribute('hidden', '');
        }
        if (ctaEl) {
          var link = slide.getAttribute('data-link');
          if (link) ctaEl.setAttribute('href', link);
        }
      }

      function go(i) {
        applySlide(i);
        /* Prefetch the upcoming slide only after a real transition */
        var upcoming = slides[(index + 1) % slides.length];
        if (upcoming) ahHydrateHeroSlide(upcoming);
        restart();
      }

      function next() {
        go(index + 1);
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (autoplayMs > 0 && slides.length > 1) {
          timer = setInterval(next, autoplayMs);
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-ah-dot') || '0', 10);
          go(i);
        });
      });

      root.addEventListener('mouseenter', function () {
        if (timer) clearInterval(timer);
      });
      root.addEventListener('mouseleave', restart);

      applySlide(0);
      /* Delay autoplay so LCP locks onto the first hero image in lab tests */
      if (autoplayMs > 0 && slides.length > 1) {
        setTimeout(restart, Math.max(autoplayMs, 8000));
      }

      var menu = root.querySelector('[data-ah-menu]');
      var nav = root.querySelector('.ah-nav');
      var chrome = root.querySelector('[data-ah-hero-chrome]');
      if (menu && nav) {
        menu.addEventListener('click', function () {
          nav.classList.toggle('is-open');
          menu.classList.toggle('is-open');
        });
        window.addEventListener('scroll', function () {
          if (!nav.classList.contains('is-open')) return;
          nav.classList.remove('is-open');
          menu.classList.remove('is-open');
          root.querySelectorAll('[data-ah-nav-drop].is-open').forEach(function (drop) {
            drop.classList.remove('is-open');
            var dropBtn = drop.querySelector('[data-ah-nav-drop-btn]');
            if (dropBtn) dropBtn.setAttribute('aria-expanded', 'false');
          });
        }, { passive: true });
      }
      if (chrome) {
        var onScrollChrome = function () {
          chrome.classList.toggle('is-scrolled', window.scrollY > 8);
        };
        onScrollChrome();
        window.addEventListener('scroll', onScrollChrome, { passive: true });
      }
    });

    document.querySelectorAll('[data-ah-arrivals]').forEach(function (root) {
      var track = root.querySelector('[data-ah-arrivals-track]');
      var prev = root.querySelector('[data-ah-arrivals-prev]');
      var next = root.querySelector('[data-ah-arrivals-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.ah-card');
        if (!card) return 260;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 20;
        return card.getBoundingClientRect().width + gap;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });

    document.querySelectorAll('[data-ah-reviews]').forEach(function (root) {
      var track = root.querySelector('[data-ah-track]');
      var prev = root.querySelector('[data-ah-prev]');
      var next = root.querySelector('[data-ah-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.ah-review');
        return card ? card.getBoundingClientRect().width + 20 : 320;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });

    document.querySelectorAll('[data-ah-ig]').forEach(function (root) {
      var track = root.querySelector('[data-ah-ig-track]');
      var prev = root.querySelector('[data-ah-ig-prev]');
      var next = root.querySelector('[data-ah-ig-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.ah-ig__slide');
        if (!slide) return 240;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 18;
        return slide.getBoundingClientRect().width + gap;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
    });
  });
})();
